<template>
  <div class="list">
    <div class="add">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="showDialog('add')">新建</el-button>
    </div>
    <br />
    <el-table v-loading="listLoading" :data="list" border style="width: 100%" size="mini">
      <el-table-column prop="sort" label="序号" align="center" />
      <el-table-column prop="name" label="名称" align="center" />
      <!-- <el-table-column prop="image" label="图片" align="center">
                <template slot-scope="scope">
                    <el-image style="height: 60px;" fit="contain" :src="imgDomain + scope.row.image" :preview-src-list="[imgDomain + scope.row.image]" />
                </template>
            </el-table-column> -->
      <el-table-column prop="url" label="跳转链接" align="center" />
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button v-if="hasEdit" type="primary" size="small" @click="showDialog('edit', scope)">编辑</el-button>
          <el-button v-if="hasDelete" type="danger" size="small" @click="handleDeleteClick(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="page">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page_index"
        :limit.sync="listQuery.page_size"
        @pagination="getList"
      />
    </div>
    <common-dialog
      :title="dialogTitle"
      :dialog-visible="dialogVisible"
      @cancel="dialogVisible = false"
      @confirm="dialogConfirmClick"
    >
      <el-form>
        <el-form-item label="*排序" label-width="80px">
          <el-input
            v-model="linkInfo.sort"
            onkeyup="value=value.replace(/[^\d]/g,'')"
            placeholder="请输入排序号"
          ></el-input>
        </el-form-item>

        <el-form-item label="*名称" label-width="80px">
          <el-input v-model="linkInfo.name" placeholder="请输入链接名称"></el-input>
        </el-form-item>

        <el-form-item label="*跳转链接" label-width="80px">
          <el-input v-model="linkInfo.url" placeholder="请输入跳转链接"></el-input>
        </el-form-item>

        <!-- <el-form-item label="图片" label-width="80px">
                    <imageUpload v-model="linkInfo.linkImg" :limit="1" />
                </el-form-item> -->
      </el-form>
    </common-dialog>
  </div>
</template>
<script>
import { linksList, addLinks, deleteLinks, getLinksDetail, editLinks } from "@/api/content.js";
import Pagination from "@/components/Pagination";
import CommonDialog from "@/components/CommonDialog";
import operations from "../../mixins/operations";
import { imgDomain } from "@/configs/env";
import imageUpload from "@/components/ImageUpload";
export default {
  components: { Pagination, CommonDialog, imageUpload },
  mixins: [operations],
  data() {
    return {
      imgDomain,
      list: [],
      dialogVisible: false,
      dialogTitle: "",
      dialogType: "",
      total: 0,
      listQuery: {
        page_index: 1,
        page_size: 10,
      },
      listLoading: false,
      uuid: "",
      linkInfo: {
        sort: "",
        name: "",
        url: "",
        // image: "",
        // linkImg: []
      },
    };
  },
  computed: {
    hasAdd() {
      return this.operations.includes("新建友情链接");
    },
    hasEdit() {
      return this.operations.includes("编辑友情链接");
    },
    hasDelete() {
      return this.operations.includes("删除友情链接");
    },
  },

  async mounted() {
    this.getList();
  },

  methods: {
    async getList(params = this.listQuery) {
      this.listLoading = true;
      const { total, data } = await linksList(params);
      this.listLoading = false;
      this.total = total;
      this.list = data;
    },

    showDialog(type, scope) {
      if (type == "add") {
        this.dialogTitle = "新建友情链接";
        this.linkInfo = {
          sort: "",
          name: "",
          url: "",
          // image: "",
          // linkImg: []
        };
      } else if (type == "edit") {
        this.uuid = scope.row.id;
        this.linkInfo = Object.assign({}, scope.row);
        // this.linkInfo.linkImg = this.linkInfo.image ? this.linkInfo.image.split() : [];
        this.dialogTitle = "编辑友情链接";
      }
      this.dialogType = type;
      this.dialogVisible = true;
    },

    async dialogConfirmClick() {
      const { sort, name, url, linkImg } = this.linkInfo;
      if (!sort) {
        return this.$notify.error({ title: "请输入排序号" });
      }
      if (!name) {
        return this.$notify.error({ title: "请输入链接名称" });
      }
      if (!url) {
        return this.$notify.error({ title: "请输入跳转链接" });
      }
      // if (this.linkInfo.linkImg.length) {
      //     this.linkInfo.image = this.linkInfo.linkImg.join();
      // }
      this.linkInfo.sort = Number(this.linkInfo.sort);
      if (this.dialogType == "add") {
        // 新建
        const res = await addLinks(this.linkInfo);
        if (res == true) {
          this.getList();
          this.$notify({ title: "新建成功", type: "success" });
          this.dialogVisible = false;
        }
      } else if (this.dialogType == "edit") {
        // 编辑
        const res = await editLinks(this.uuid, this.linkInfo);
        if (res == true) {
          this.getList();
          this.$notify({ title: "编辑成功", type: "success" });
          this.dialogVisible = false;
        }
      }
    },

    handleDeleteClick(uuid) {
      this.$confirm(`是否删除该友情链接？`, "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(async () => {
          await deleteLinks(uuid);
          this.getList();
          this.$notify({ title: "删除成功", type: "success" });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.add {
  float: right;
  margin-bottom: 20px;
}
</style>
